module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_28.77028faf.png";